module.exports = __webpack_public_path__ + "static/media/Bath.147c05b9.PNG";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/buttons/Bath.PNG
// module id = 66
// module chunks = 0